import { api } from "services"

export async function getClientMembers() {
  const { data } = await api.get("/client-members?asList=1")
  
  return data
}